exports.install = function (Vue, options) {
	Vue.prototype.api.user = {
		index()//个人信息
		{
			return Vue.prototype.axiosget("/api/rl/User/index")
			.then((response)=>{
				return response;
			});
		},
		login(value)//登录
		{
			value.loginWay = 1;
			return Vue.prototype.axiospost("/api/rl/User/login",value)
			.then((response)=>{
				if(response.data.code==1)
				{
					Vue.prototype.setCookie(Vue.prototype.config.token,response.data.data.userInfo.token,3);
					Vue.prototype.router.push("/test");
				}
				return response;
			});
		},
		register(value)//注册
		{
			return Vue.prototype.axiospost("/api/rl/User/register",value)
			.then((response)=>{
				if(response.data.code==1)
				{
					Vue.prototype.setCookie(Vue.prototype.config.token,response.data.data.userInfo.token,3);
					Vue.prototype.router.push("/test");
				}
				return response;
			});
		},
		logout()//退出登录
		{
			return Vue.prototype.axiospost("/api/user/logout")
			.then((response)=>{
				return response;
			});
		},
		findPassword(value)//找回密码
		{
			return Vue.prototype.axiospost("/api/rl/User/findPassword",value)
			.then((response)=>{
				return response;
			});
		},
		resetPassword(value)//重置密码
		{
			return Vue.prototype.axiospost("/api/user/findPassword",value)
			.then((response)=>{
				return response;
			});
		},
		profile(value)//修改个人信息
		{
			return Vue.prototype.axiospost("/api/rl/User/updateUser",value)
			.then((response)=>{
				return response;
			});
		},
		addCompanyUser(value)//企业账号添加人员
		{
			return Vue.prototype.axiospost("/api/rl/User/addUser",value)
			.then((response)=>{
				return response;
			});
		},
		getUserList(value={})//企业人员列表
		{
			return Vue.prototype.axiosget("/api/rl/User/getList",value)
			.then((response)=>{
				return response;
			});
		}
	};
}